module.exports = __webpack_public_path__ + "media/images/japan/location_3-79867dd6fd84b3683bada1612c03bdd3.png";